module.exports = __webpack_public_path__ + "img/pethouse07.7c86f403.jpg";